import * as history from 'history';
import { SessionUser } from "features/Security/state/types";
import { Dealer } from "../DealerSelect/state/types";
import { ApiEngineDealer, EngineDealer, ApiListing, Listing } from "./types";

export const parseAPIListing = (apiLising: ApiListing): Listing => {
    if (apiLising!=null)
    {
     return{
            id: apiLising.id,
            dealerId: apiLising.dealerId,
            listingType: apiLising.listingType,
            idInSource:apiLising.idInSource,
            engineId: apiLising.engineId,
            listingTypeId: apiLising.listingTypeId,
            statusSync:apiLising.statusSync
        }    
    }
    else
    {
        return{
            id: "",
            dealerId: "",
            listingType: "",
            idInSource: "",
            engineId: "",
            listingTypeId: "",
            statusSync: ""
        }    
    }
}

export const parseAPIEngineDealer = (apiEngineDealer: ApiEngineDealer): EngineDealer => {
    if (apiEngineDealer!=null)
    {
     return{
            id: apiEngineDealer.id,
            idDealer: apiEngineDealer.idDealer,
            idEngine: apiEngineDealer.idEngine,
            businessId:apiEngineDealer.businessId,
            statusActived: apiEngineDealer.statusActived,
            statusConected: apiEngineDealer.statusConected,
            statusSync:apiEngineDealer.statusSync

        }    
    }
    else
    {
        return{
            id: "",
            idDealer: "",
            idEngine: "",
            businessId:"",
            statusActived: "",
            statusConected: "",
            statusSync:""

        }    
    }
}

export const checkOrganizations = (group: string, organizations?: string[], ) => {
    let isEqual = false;
    organizations?.map(organization => {if (organization === group) isEqual = true; return;})
    return isEqual;
}

export const hasDealerPermissions = (location: history.Location, user: SessionUser, dealers: Dealer[]) => {
    const urlDealerId = new URLSearchParams(location.search).get('dealer');
    let hasPermissions = urlDealerId !== user.dealerId ? false : true;
    dealers.map(dealer => {
        try {
            const userDealerGroups: string[] = JSON.parse(user.dealerGroup);
            userDealerGroups?.map(userGroup => {
                if (dealer.dealerGroup === userGroup || checkOrganizations(userGroup, dealer.dealerOrganizations)) {
                    hasPermissions = true;
                    return;
                }
            });
        } catch {
            if (dealer.dealerGroup === user.dealerGroup || checkOrganizations(user.dealerGroup, dealer.dealerOrganizations)) {
                hasPermissions = true;
                return;
            }
        }
    })
    return hasPermissions;
}